// Product recommendation tabs.
document.addEventListener('DOMContentLoaded', function () {
document.querySelectorAll('.cus-prd-coll-tbs-bv--section').forEach((section) => {
  section.flickityInstances = {};
  section.querySelectorAll('.cus-prd-coll-tbs-bv--pane .js-flickity').forEach(slider => {
    const pane = slider.closest('.cus-prd-coll-tbs-bv--pane');
    if (!pane || !window.Flickity) return;
    const wasHidden = pane.style.display === 'none' || getComputedStyle(pane).display === 'none';
    if (wasHidden) pane.style.display = 'block';

    let options = {};
    try {
      options = JSON.parse(slider.dataset.flickity || '{}');
    } catch (error) {
      console.warn('Invalid Flickity options; using defaults.', error);
    }
    section.flickityInstances[pane.id] = Flickity.data(slider) || new Flickity(slider, options);
    if (wasHidden) pane.style.display = '';
  });

  section.querySelectorAll('.cus-prd-coll-tbs-bv--tab').forEach((tab) => {
    tab.addEventListener('click', function () {
      section.querySelectorAll('.cus-prd-coll-tbs-bv--tab').forEach(t => t.classList.remove('active'));
      section.querySelectorAll('.cus-prd-coll-tbs-bv--pane').forEach(p => p.classList.remove('active'));
      this.classList.add('active');
      const activePane = document.getElementById(this.dataset.tab);
      if (!activePane || !section.contains(activePane)) return;
      activePane.classList.add('active');
      if (section.flickityInstances[activePane.id]) {
        section.flickityInstances[activePane.id].resize();
      }
    });
  });
});
});

// ---------------------------------------------icon phone header---------------------------------

document.addEventListener("DOMContentLoaded", () => {
  const drawer = document.querySelector(".cus_phn_em_cnt__drawer");
  const overlay = document.querySelector(".cus_phn_em_cnt__overlay");
  if (!drawer || !overlay) return;
  const contactClose = drawer.querySelector(".cus_phn_em_cnt__close");
  let contactOpenedBy = null;
  let contactCloseTimer = null;
  let restoreContactFocus = true;
  const openContact = (btn) => {
    window.clearTimeout(contactCloseTimer);
    restoreContactFocus = true;
    contactOpenedBy = btn;
    document.dispatchEvent(new CustomEvent('jb:contact-open'));
    drawer.classList.remove("closing");
    drawer.removeAttribute('inert');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add("active");
    overlay.classList.add("active");
    btn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('jb-contact-open');
    contactClose?.focus({ preventScroll: true });
  };
  document.querySelectorAll(".cus_cnt_em_us_icn").forEach(btn => {
    if (!btn.matches('button, a, input, select, textarea')) {
      btn.setAttribute('role', 'button');
      btn.setAttribute('tabindex', '0');
    }
    btn.setAttribute('aria-haspopup', 'dialog');
    btn.setAttribute('aria-controls', 'jb-contact-drawer');
    btn.setAttribute('aria-expanded', 'false');
  });
  // Delegation also covers product sections replaced by Shopify variant navigation.
  document.addEventListener('click', event => {
    const btn = event.target.closest?.('.cus_cnt_em_us_icn');
    if (!btn) return;
    event.preventDefault();
    openContact(btn);
  });
  document.addEventListener('keydown', event => {
    const btn = event.target.closest?.('.cus_cnt_em_us_icn');
    if (!btn || btn.matches('button,a,input,select,textarea')) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    openContact(btn);
  });

  const closeDrawer = (restoreFocus = true) => {
    if (restoreFocus === false) restoreContactFocus = false;
    if (!drawer.classList.contains('active')) return;
    drawer.classList.remove("active");
    drawer.classList.add("closing");
    drawer.setAttribute('aria-hidden', 'true');
    contactOpenedBy?.setAttribute('aria-expanded', 'false');
    overlay.classList.remove("active");
    window.clearTimeout(contactCloseTimer);
    contactCloseTimer = window.setTimeout(() => {
      drawer.classList.remove("closing");
      drawer.setAttribute('inert', '');
      document.body.classList.remove('jb-contact-open');
      if (restoreContactFocus && contactOpenedBy?.isConnected) contactOpenedBy.focus({ preventScroll: true });
      contactOpenedBy = null;
      document.dispatchEvent(new CustomEvent('panel:closed'));
    }, 650);
  };

  contactClose?.addEventListener("click", closeDrawer);
  overlay.addEventListener("click", closeDrawer);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });
  ['jb:menu-open', 'jb:search-open', 'jb:panel-open', 'jb:request-open', 'panel:open'].forEach(name => {
    document.addEventListener(name, () => closeDrawer(false));
  });

  document.querySelectorAll("[data-acc]").forEach(item => {
    item.addEventListener("click", () => {
      const parent = item.closest(".cus_phn_em_cnt__item");
      const icon = item.querySelector(".cus_phn_em_cnt__icon");

      document.querySelectorAll(".cus_phn_em_cnt__item").forEach(acc => {
        if (acc !== parent) {
          acc.classList.remove("active");
          const otherIcon = acc.querySelector(".cus_phn_em_cnt__icon");
          if (otherIcon) otherIcon.textContent = "+";
          const otherButton = acc.querySelector('[data-acc]');
          const otherBody = acc.querySelector('.cus_phn_em_cnt__item-body');
          otherButton?.setAttribute('aria-expanded', 'false');
          if (otherBody) otherBody.hidden = true;
        }
      });

      if (!parent || !icon) return;
      parent.classList.toggle("active");
      const isActive = parent.classList.contains("active");
      item.setAttribute('aria-expanded', String(isActive));
      const body = parent.querySelector('.cus_phn_em_cnt__item-body');
      if (body) body.hidden = !isActive;
      icon.textContent = isActive ? "−" : "+";
    });
  });

});


// {% comment %} --------------------------------------customizer product custom block------------------------------------ {% endcomment %}

document.addEventListener('DOMContentLoaded', function(){
  const wrapper = document.querySelector('.cus_drw_cst_prd_blk_wrapper');
  if(!wrapper) return;
  const drawer = wrapper.querySelector('.cus_drw_cst_prd_blk_drawer');
  const overlay = wrapper.querySelector('.cus_drw_cst_prd_blk_overlay');
  const messageField = wrapper.querySelector('.cus_drw_cst_prd_blk_message_field');
  const openButton = wrapper.querySelector('.cus_drw_cst_prd_blk_btn');
  const closeButton = wrapper.querySelector('.cus_drw_cst_prd_blk_close');
  const confirmButton = wrapper.querySelector('.cus_drw_cst_prd_blk_confirm');
  const fontInput = wrapper.querySelector('.cus_drw_cst_prd_blk_font_input');
  const symbolInput = wrapper.querySelector('.cus_drw_cst_prd_blk_symbol_input');
  if (!drawer || !overlay || !messageField || !openButton || !closeButton || !confirmButton || !fontInput || !symbolInput) return;
  let selectedFont = '';
  /* drawer open */
  openButton.addEventListener('click', function(){
    drawer.classList.add('active');
    overlay.classList.add('active');
  });
  /* drawer close */
  function closeDrawer(){
    drawer.classList.remove('active');
    overlay.classList.remove('active');
  }
  closeButton.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  /* font select */
    const fontButtons = wrapper.querySelectorAll('.cus_drw_cst_prd_blk_font_btn');
		if(fontButtons.length){
		fontButtons[0].classList.add('active');
		selectedFont = fontButtons[0].dataset.value;
		}
		fontButtons.forEach(btn => {
		btn.addEventListener('click', function(){

			fontButtons.forEach(item => {
			item.classList.remove('active');
			});
			this.classList.add('active');
			selectedFont = this.dataset.value;
		});
		});
  /* symbol click → directly add into input (max 7) */
  wrapper.querySelectorAll('.cus_drw_cst_prd_blk_symbol_btn').forEach(btn => {

    btn.addEventListener('click', function(){

      let symbol = this.dataset.value;
      let currentValue = messageField.value;

      if(currentValue.length < 7){
        messageField.value = currentValue + symbol;
      }
    });
  });
  /* manual input max 7 */
  messageField.addEventListener('input', function(){

    if(this.value.length > 7){
      this.value = this.value.slice(0, 7);
    }

  });
  /* confirm */
  confirmButton.addEventListener('click', function(){
  const messageValue = messageField.value;
  fontInput.value = selectedFont;
  symbolInput.value = messageValue;
  // {% comment %} wrapper.querySelector('.cus_drw_cst_prd_blk_message_input').value = messageValue; {% endcomment %}
  closeDrawer();
	});

	const termsCheck = wrapper.querySelector('.cus_drw_cst_prd_blk_terms_check');
	if (termsCheck) {
	  termsCheck.addEventListener('change', function(){
	    confirmButton.disabled = !this.checked;
	  });
	}

});



// Just Brilliant size guides reconnect after Shopify replaces product content.
if (!customElements.get('jb-size-guide')) {
  customElements.define('jb-size-guide', class extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.cus_sz_chrt_jsb__btn');
      this.dialog = this.querySelector('dialog');
      if (!this.trigger || !this.dialog || this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.trigger.addEventListener('click', () => this.open(), options);
      this.querySelector('.cus_sz_chrt_jsb__close').addEventListener('click', () => this.close(), options);
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); }, options);
      this.dialog.addEventListener('click', event => {
        const rect = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.close();
      }, options);
    }
    open() {
      clearTimeout(this.closeTimer);
      if (!this.dialog.open) {
        this.previousOverflow = document.body.style.overflow;
        this.dialog.showModal();
      }
      document.body.style.overflow = 'hidden';
      this.dialog.classList.remove('is-closing');
      this.dialog.setAttribute('aria-hidden', 'false');
      this.trigger.setAttribute('aria-expanded', 'true');
      this.querySelector('.cus_sz_chrt_jsb__close').focus();
      document.dispatchEvent(new CustomEvent('panel:open'));
    }
    close() {
      if (!this.dialog.open || this.dialog.classList.contains('is-closing')) return;
      this.dialog.classList.add('is-closing');
      const delay = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 250;
      this.closeTimer = setTimeout(() => {
        this.dialog.close();
        this.dialog.classList.remove('is-closing');
        this.dialog.setAttribute('aria-hidden', 'true');
        this.trigger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = this.previousOverflow || '';
        this.trigger.focus({ preventScroll: true });
        document.dispatchEvent(new CustomEvent('panel:closed'));
      }, delay);
    }
    disconnectedCallback() {
      clearTimeout(this.closeTimer);
      this.controller?.abort();
      this.controller = null;
      if (this.dialog?.open) {
        this.dialog.close();
        document.body.style.overflow = this.previousOverflow || '';
        document.dispatchEvent(new CustomEvent('panel:closed'));
      }
    }
  });
}

// ---------------------------------------------cus heaer menu newsletter drawer form------------------

document.addEventListener('DOMContentLoaded', function(){
    const trigger = document.querySelector('.cus_new_ltr_men_item');
    const drawer = document.querySelector('.cus_nwl_jsb_frm__drawer');
    const overlay = document.querySelector('.cus_nwl_jsb_frm__overlay');
    const closeBtn = document.querySelector('.cus_nwl_jsb_frm__close');
    if (!trigger || !drawer || !overlay || !closeBtn) return;

    function closeDrawer(){
      drawer.classList.remove('active');
      overlay.classList.remove('active');
    }

    trigger.addEventListener('click', function(){
      drawer.classList.add('active');
      overlay.classList.add('active');
    });

    closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
  });

  // ----------------------------------------------------custom-request-price---------------------

document.addEventListener("DOMContentLoaded", function () {
  const popup = document.querySelector(".cus_request_price_overlay");
  const closeBtn = document.querySelector(".cus_request_price_close");
  if (!popup) return;
  let requestOpenedBy = null;
  let previousOverflow = '';

  function openRequestForm(button) {
    if (popup.classList.contains('active')) return;
    requestOpenedBy = button || document.activeElement;
    document.dispatchEvent(new CustomEvent('jb:request-open'));
    previousOverflow = document.body.style.overflow;
    if (button) {
      const info = button.closest('.product-information--inner, .product-information') || document;
      const shareState = info.querySelector('[data-jb-share-state]');
      const variant = info.querySelector('form input[name="id"]')?.value || shareState?.dataset.variantId || '';
      const url = new URL(button.dataset.productUrl || location.pathname, location.origin);
      if (variant) url.searchParams.set('variant', variant);
      const values = {
        'Product Name': button.dataset.productTitle || info.querySelector('.product-title')?.textContent.trim() || '',
        'Product URL': url.href,
        'SKU': info.querySelector('.product-sku')?.textContent.trim() || shareState?.dataset.sku || '',
        'Variant ID': variant
      };
      for (const [key, value] of Object.entries(values)) {
        const field = popup.querySelector(`[name="contact[${key}]"]`);
        if (field) field.value = value;
      }
      button.setAttribute('aria-expanded', 'true');
    }
    popup.classList.add("active");
    popup.removeAttribute('inert');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = "hidden";
    closeBtn?.focus({ preventScroll: true });
  }

  function closeRequestForm(restoreFocus = true) {
    if (!popup.classList.contains('active')) return;
    popup.classList.remove("active");
    popup.setAttribute('aria-hidden', 'true');
    popup.setAttribute('inert', '');
    document.body.style.overflow = previousOverflow;
    requestOpenedBy?.setAttribute('aria-expanded', 'false');
    if (restoreFocus !== false && requestOpenedBy?.isConnected) requestOpenedBy.focus({ preventScroll: true });
    requestOpenedBy = null;
  }

  // Product sections can be replaced during variant / combined-listing navigation.
  document.addEventListener('click', event => {
    const button = event.target.closest?.('button.jb-request-price-button');
    if (!button) return;
    event.preventDefault();
    openRequestForm(button);
  });
  // CLOSE button
  if (closeBtn) {
    closeBtn.addEventListener("click", closeRequestForm);
  }
  // CLICK OUTSIDE CLOSE
  popup.addEventListener("click", function (e) {
    if (e.target === popup) closeRequestForm();
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeRequestForm();
  });
  ['jb:menu-open', 'jb:search-open', 'jb:panel-open', 'jb:contact-open', 'panel:open'].forEach(name => {
    document.addEventListener(name, () => closeRequestForm(false));
  });
  if (popup.querySelector('[data-request-feedback]') && location.hash === '#RequestPriceForm') openRequestForm();
});

// Just Brilliant reveal header: hide on downward travel and return on upward travel.
document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('#header.header');
  if (!header) return;

  let lastScroll = window.scrollY;
  let ticking = false;

  function showHeader() {
    header.classList.remove('jb-header-hidden');
    header.classList.add('jb-header-revealed');
  }

  function updateHeader() {
    const currentScroll = window.scrollY;
    const navigationIsOpen = document.querySelector('.jb-drawer.is-open, .jb-drawer.is-closing, .jb-search.is-open, .jb-right-panel.is-open');
    const movement = currentScroll - lastScroll;

    if (currentScroll <= 80) {
      header.classList.remove('jb-header-hidden', 'jb-header-revealed');
    } else if (navigationIsOpen) {
      showHeader();
    } else if (movement > 4) {
      header.classList.add('jb-header-hidden');
      header.classList.remove('jb-header-revealed');
    } else if (movement < -4) {
      showHeader();
    }

    lastScroll = currentScroll;
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (ticking) return;
    window.requestAnimationFrame(updateHeader);
    ticking = true;
  }, { passive: true });

  document.addEventListener('jb:menu-open', showHeader);
  document.addEventListener('jb:menu-close', function () {
    lastScroll = window.scrollY;
  });
});

// ---------------------------------------------------custom product media gallery------------------------------

	document.addEventListener("DOMContentLoaded", function () {
      if (!window.matchMedia("(min-width: 1068px)").matches) return;
      const slider = document.querySelector(".custm_two_column_slder_list_container #Product-Slider");
      const prevBtn = document.querySelector(".custm_two_column_slder_list_container .slider-button--prev");
      const nextBtn = document.querySelector(".custm_two_column_slder_list_container .slider-button--next");
      const currentEl = document.querySelector(".custm_two_column_slder_list_container .slider-counter--current");
      const totalEl = document.querySelector(".custm_two_column_slder_list_container .slider-counter--total");

      if (!slider) return;

      const slides = slider.querySelectorAll(".custm_two_column_slder_list_container .product-images__slide");
      const totalSlides = slides.length;
      if (!totalSlides) return;

      let slideWidth = slides[0].offsetWidth;
      let currentIndex = 0;

      if (totalEl) totalEl.textContent = totalSlides;

      function updateSlider() {
        slideWidth = slides[0].offsetWidth;

        slider.scrollTo({
        left: currentIndex * slideWidth,
        behavior: "smooth"
        });

        if (currentEl) currentEl.textContent = currentIndex + 1;

        if (prevBtn) prevBtn.disabled = currentIndex === 0;
        if (nextBtn) nextBtn.disabled = currentIndex >= totalSlides - 2;
      }

      prevBtn?.addEventListener("click", () => {
        if (currentIndex > 0) {
        currentIndex--;
        updateSlider();
        }
      });

      nextBtn?.addEventListener("click", () => {
        if (currentIndex < totalSlides - 2) {
        currentIndex++;
        updateSlider();
        }
      });

      let isDragging = false;
      let startX;
      let startScroll;

      slider.addEventListener("mousedown", (e) => {
        isDragging = true;
        slider.style.cursor = "grabbing";
        startX = e.pageX;
        startScroll = slider.scrollLeft;
      });

      document.addEventListener("mouseup", () => {
        if (!isDragging) return;

        isDragging = false;
        slider.style.cursor = "grab";

        currentIndex = Math.round(slider.scrollLeft / slideWidth);
        updateSlider();
      });

      slider.addEventListener("mousemove", (e) => {
        if (!isDragging) return;

        e.preventDefault();

        const walk = e.pageX - startX;
        slider.scrollLeft = startScroll - walk;
      });

      slider.addEventListener("touchend", () => {
        currentIndex = Math.round(slider.scrollLeft / slideWidth);
        updateSlider();
      });

      window.addEventListener("resize", updateSlider);

      updateSlider();

	});

  // -------------------------------------------------------------------product page add to cart show hide with variant price-----------------

//   document.addEventListener("change", () => {
//     setTimeout(() => {
//     const selected = document.querySelector('[id^="SelectedVariant"]');
//     const btn = document.querySelector('.cus_crt_add_btn_wrp');
//     if (!selected || !btn) return;
//     const variantId = selected.dataset.variantId;
//     const activeInput = document.querySelector('input:checked');
//     if (!activeInput) return;
//     const price = activeInput.getAttribute('cus-data-price');
//     btn.style.display = (price == "0" || price == 0) ? "none" : "block";
//    }, 100);
// });


// ---------------------------------------------------------------------------custom js size chart size guide------------------------------

document.addEventListener('DOMContentLoaded', function () {
    const popup = document.getElementById('cus_sz_chrt_tbl__popup');
    const closeBtn = document.getElementById('cus_sz_chrt_tbl__close');
    if (!popup) return;

    // Open popup from any button (even dynamically loaded)
    document.addEventListener('click', function(e) {
        if (e.target.closest('.cus_sz_chrt_tbl__open')) {
            popup.classList.add('active');
            document.body.style.overflow = 'hidden';
        }
    });

    function closePopup() {
        popup.classList.remove('active');
        document.body.style.overflow = '';
    }

    if(closeBtn){
        closeBtn.addEventListener('click', closePopup);
    }

    popup.addEventListener('click', function(e) {
        if (e.target === popup) {
            closePopup();
        }
    });
});

// Provide one consistent keyboard escape route for custom drawers and overlays.
document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;
  if (document.querySelector('dialog[open]')) return;

  const legacyOverlays = document.querySelectorAll(
    '.cus_drw_cst_prd_blk_drawer.active, .cus_drw_cst_prd_blk_overlay.active, ' +
    '.cus_sz_chrt_jsb__popup.active, .cus_sz_chrt_jsb__overlay.active, ' +
    '.cus_nwl_jsb_frm__drawer.active, .cus_nwl_jsb_frm__overlay.active, ' +
    '#cus_sz_chrt_tbl__popup.active'
  );
  if (legacyOverlays.length) {
    legacyOverlays.forEach((element) => element.classList.remove('active'));
    document.body.style.overflow = '';
  }
});


// Just Brilliant: contain keyboard focus inside open custom modal panels.
// Native dialogs retain the browser's built-in focus handling.
document.addEventListener('keydown', function (event) {
  if (event.key !== 'Tab' || event.defaultPrevented || document.querySelector('dialog[open]')) return;
  const visible = element => !element.closest('[hidden], [inert], [aria-hidden="true"]') &&
    element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
  const dialogs = Array.from(document.querySelectorAll('[role="dialog"][aria-modal="true"][aria-hidden="false"]')).filter(visible);
  if (!dialogs.length) return;
  const modal = dialogs.find(element => element.contains(document.activeElement)) || dialogs[dialogs.length - 1];
  const items = Array.from(modal.querySelectorAll('a[href], button, input, select, textarea, [tabindex], [contenteditable="true"]'))
    .filter(element => element.tabIndex >= 0 && !element.matches(':disabled') && visible(element));
  if (!items.length) {
    event.preventDefault();
    if (!modal.hasAttribute('tabindex')) modal.setAttribute('tabindex', '-1');
    modal.focus({ preventScroll: true });
    return;
  }
  const first = items[0], last = items[items.length - 1];
  if (!modal.contains(document.activeElement) ||
      (event.shiftKey && (document.activeElement === first || document.activeElement === modal)) ||
      (!event.shiftKey && document.activeElement === last)) {
    event.preventDefault();
    (event.shiftKey ? last : first).focus({ preventScroll: true });
  }
});


